import { z } from 'zod'

export const STRATALYST_FORM_SEND_CONTRACT_VERSION = '1.0.0' as const
const passthroughResponseSchema = z.unknown()

export const stratalystFormSendCreateResponseSchema = passthroughResponseSchema
export const stratalystFormSendListResponseSchema = passthroughResponseSchema
export const stratalystFormSendDetailResponseSchema = passthroughResponseSchema
export const stratalystFormSendRevokeResponseSchema = passthroughResponseSchema
export const stratalystFormSchemaResponseSchema = passthroughResponseSchema
export const stratalystFormSendResponseDetailResponseSchema = passthroughResponseSchema
export const stratalystPublicFormFillGetResponseSchema = passthroughResponseSchema
export const stratalystPublicFormFillSubmitResponseSchema = passthroughResponseSchema

export type StratalystFormSendCreateResponse = z.infer<typeof stratalystFormSendCreateResponseSchema>
export type StratalystFormSendListResponse = z.infer<typeof stratalystFormSendListResponseSchema>
export type StratalystFormSendDetailResponse = z.infer<typeof stratalystFormSendDetailResponseSchema>
export type StratalystFormSendRevokeResponse = z.infer<typeof stratalystFormSendRevokeResponseSchema>
export type StratalystFormSchemaResponse = z.infer<typeof stratalystFormSchemaResponseSchema>
export type StratalystFormSendResponseDetailResponse = z.infer<typeof stratalystFormSendResponseDetailResponseSchema>
export type StratalystPublicFormFillGetResponse = z.infer<typeof stratalystPublicFormFillGetResponseSchema>
export type StratalystPublicFormFillSubmitResponse = z.infer<typeof stratalystPublicFormFillSubmitResponseSchema>
